// Vertical
export const D3_GRAPH_NODE_SEP = 80
// Horizontal
export const D3_GRAPH_RANK_SEP = 80

export const MEAN_SHIFTER = 2.5758
